/*
 * @Author: JamesWong
 * @Description: 首页繁体
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:13:03
 */

export default {
  productName: '犀牛EPOS企業管理後臺',
  companyNo: '企業編號',
  companyEnterTips: '請輸入企業編號',
  account: '登錄帳號',
  accountEnterTips: '請輸入登錄帳號',
  password: '輸入密碼',
  '剩余天数': '，剩余天數',
  passwordEnterTips: '請輸入密碼',
  login: '登錄',
  Logout: '退出',
  backHome: '返回首頁',
  openedService: '已開通的服務',
  sellModel: '收銀模組',
  foundational: '基礎物流',
  appVersion: '應用版本',
  authChannel: '授權店鋪',
  allAuthChannel: '總授權店鋪數',
  authWarehouse: '授權倉庫',
  authMumber: '已授權數',
  remainAuthNum: '剩餘可授權數',
  whalesaleSelected: '批發零售版選用',
  deviceActivateManagement: '設備啟動管理',
  subScreen: '副屏交互設置',
  displayMode: '顯示模式',
  rollingDisplay: '輪播圖片',
  advertisementVideo: '廣告視頻',
  ticketDisposition: '小票配置',
  selfcashierDisposition: '自收銀配置',
  onlinePayDisposition: '線上支付配置',
  accountModule: '帳戶',
  foundationalSet: '物流模組配置',
  depositReceipt: '定金單配置',
  loginNumTips: '企業編號不能為空！',
  loginAccountTips: '登錄帳號不能為空！',
  alipayCall: '完成授權，請回到犀牛EPOS管理後臺查看授權結果',
  noSet: '未配置, 物流功能不能正常使用',
  storeAuthorizaedManage: '店鋪授權管理',
  manageAllFacility: '設備歸屬管理',
  record: '門店登錄記錄',
  authorizedMessage: '授權信息',
  '收银模块': '收銀模塊',
  '物流模块': '物流模塊',
  '其他': '其他',
  changeLog: '設備變更記錄',
  'deviceChangeLog': '設備變更記錄',
  'deviceUntiedLog': '設備解綁記錄',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模塊',
  collaboraivePlatformSet: '協同平臺設置',
  styleTicketManager: '單據打印樣式管理',
  '查看合同': '查看合同'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/main.js